import useTitle from '@/hooks/useTitle';
import useAppStore from '@/store/app';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

export default function TenantLayout() {
  useTitle('Tenant');
  const { setNavigation } = useAppStore();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setNavigation({
      base: '/admin',
      items: [
        {
          title: 'IAM',
          subitems: [
            { title: 'Accounts', slug: 'accounts' },
            { title: 'Rollen', slug: 'roles' },
            { title: 'Teams', slug: 'teams' },
          ],
        },
        { title: 'Schnittstellen', slug: 'interfaces' },
        { title: 'Theme', slug: 'administration' },
        {
          title: 'Abrechnung',
          subitems: [
            // { title: 'Zeitbuchungen', slug: 'timeRecords' },
            // { title: 'Leistungsnachweise', slug: 'performanceRecords' },
            // { title: 'Rechnungen', slug: 'invoices' },
            { title: 'Zahlungsmethoden', slug: 'paymentMethods' },
          ],
        },
        { title: 'Verwaltung', slug: 'organization' },
      ],
    });
    if (pathname === '/admin') navigate('/admin/accounts');
  }, []);

  return (
    <Box sx={{ display: 'flex', flex: 1, height: '100%' }}>
      <Box
        sx={{
          flexGrow: 1,
          backgroundColor: 'rgba(0, 0, 0, 0.01)',
          overflow: 'auto',
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
